export default __webpack_public_path__ + "static/media/parrot-cutout-bitesize.595b4916.png";